import { isProdEnv } from './errorUtils';

export const isAnalyticsEligible = () => {
  if (!isProdEnv || typeof window === 'undefined') {
    return false;
  }

  if (/ReactSnap/.test(navigator.userAgent)) {
    return false;
  }

  return window.location.hostname !== 'localhost';
};
